import React, { Component } from 'react';
import cx from 'classnames';
import { string, number } from 'prop-types';
import grad from 'gradient-from-image';

import { Card, CardDescription, Icon } from '../';

const CLASS_ROOT = 'instagram';

const propTypes = {
  image: string,
  href: string,
  caption: string,
  likes: number,
};

class Instagram extends Component {
  constructor(props) {
    super(props);
    this.setEqualHeight = this.setEqualHeight.bind(this);
    this.setGradient = this.setGradient.bind(this);
  }

  state = {
    gradient: '',
  };

  componentDidMount() {
    this.setEqualHeight();
    window.addEventListener('resize', () => {
      this.setEqualHeight();
    });
    this.setGradient();
  }

  setEqualHeight() {
    if (this.ref) {
      const width = this.ref.getBoundingClientRect().width;
      this.ref.style.height = `${width}px`;
    }
  }

  setGradient() {
    grad.solid(this.props.image).then(solid => {
      if (solid.LightMuted && solid.Muted) {
        let bg =
          'linear-gradient(' +
          [
            `rgba(${solid.LightMuted._rgb}, 0.9)`,
            `rgba(${solid.Muted._rgb}, 0.9)`,
          ] +
          ')';
        this.setState({ gradient: bg });
      }
    });
  }

  render() {
    const {
      className,
      style,
      image,
      href,
      caption,
      likes,
      ...other
    } = this.props;

    const classes = cx(CLASS_ROOT, className);

    const returnLikes = likes && (
      <div className="text-center d-flex-column align-self-middle align-self-center">
        <Icon name="like" size="large" />
        {likes}
      </div>
    );

    return (
      <Card
        className={classes}
        cardRef={ref => {
          this.ref = ref;
        }}
        {...image && { style: { background: `url(${image})`, ...style } }}
        {...other}
      >
        {/* <Image className="instagram__image no-mrg" src={image} alt="" isFluid /> */}
        <CardDescription
          content={{ content: caption && caption }}
          externalHref={href}
          {...{ style: { background: this.state.gradient } }}
        >
          {returnLikes}
        </CardDescription>
      </Card>
    );
  }
}

Instagram.propTypes = propTypes;

export default Instagram;
